import { getViewportHeight } from "./breakpoints";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

/* STEPS */
export const FADE_HORIZONTAL_STEP_DISTANCE_FACTOR = 0.85;

export const getStepRange = (
  step: number,
  offsetFactor: number = 0,
  distanceFactor: number = 1
) => {
  const triggerOffset = Math.round(getViewportHeight() * offsetFactor);
  const stepDistance = getViewportHeight() * distanceFactor;

  return {
    start: `top+=${Math.round(step * stepDistance + triggerOffset)} top`,
    end: `+=${Math.round(stepDistance)}`,
  };
};

/* ZOOM */
export function watchDevicePixelRatio(scrollTrigger: ScrollTrigger) {
  function handleChange() {
    const ratio = window.devicePixelRatio;
    if (ratio >= 2) scrollTrigger.disable();
    else scrollTrigger.enable();
    const newMedia = window.matchMedia(
      `(resolution: ${window.devicePixelRatio}dppx)`
    );
    newMedia.addEventListener("change", handleChange, { once: true });
  }

  // Initial listener
  const media = window.matchMedia(
    `(resolution: ${window.devicePixelRatio}dppx)`
  );
  media.addEventListener("change", handleChange, { once: true });
  // Initial setter
  if (window.devicePixelRatio >= 2) scrollTrigger.disable();
}
